import { Controller as BaseController } from "@hotwired/stimulus"

export class Controller extends BaseController {
  submit() {
    this.element.submit()
  }
}
